import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/api';
import { Conta } from 'src/app/admihair/api/dto/conta';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ContaService } from 'src/app/admihair/service/conta.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-conta-inserir',
  templateUrl: './conta-inserir.component.html',
  styleUrls: ['./conta-inserir.component.scss']
})
export class ContaInserirComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  permissaoInserir: boolean = false;
  messages: Message[] = []; 
  empresaSelecionada?: Empresa;
  messagemVisivel: boolean = false;

  conta: Conta = {};
  tipoConta: string[] = ['AJUSTE', 'BANCO', 'CAIXA'];
  tipoSelecionado: any;
  progressoRequisicao: boolean = false;

  constructor(private utilStorageService: UtilStorageService,
    private contaService: ContaService,
    private erroService: ErroService) { }


  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_CONTA');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
  }

  salvar(){
    this.progressoRequisicao = true;
    this.conta.empresa = this.empresaSelecionada;
    this.contaService.salvar(this.conta).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.limparFormulario();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    })
  }

  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

  limparFormulario(){
    this.form?.reset(); 
  }
  
}
